import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
  selector: '[ad-host]',
})
export class DynamicItemDirective {
  constructor(public viewContainerRef: ViewContainerRef) { }
}
